import { UpdateConsentInput } from '@buy-viasat/types/build/bv';
import api, { apiEndpoints } from 'shared/services/axios';

export async function updateConsentRest({ cartId, productCandidateIds }: UpdateConsentInput): Promise<void> {
  await api.post(apiEndpoints.updateEic, { cartId, productCandidateIds });
}
